import { Component } from "react";
import t from "prop-types";
import { getNetworkTestSessionCreds as getNetworkTestSessionCredsPromise,
  logNetworkQualityTest as logNetworkQualityTestPromise } from "@app/routes/users/api";
import OTNetworkTest from "opentok-network-test-js";
import OT from "@opentok/client";
import _ from "lodash";
import {
  engineName,
  isMobile,
  browserVersion,
  deviceType,
  osVersion,
  osName,
  browserName,
  // deviceDetect,
} from "react-device-detect";
import { trackEvent } from "@amplio-common/analytics";
import { getDownloadSpeed, getUploadSpeed } from "@amplio-common/funcs/performanceTests";

const propTypes = {
  onEnd: t.func,
  isManualTest: t.bool,
};

class NetworkTest extends Component {
  componentDidMount() {
    this.runTest();
  }

  runTest = () => {
    this.results = {
      is_manual: this.props.isManualTest || false,
    };
    getNetworkTestSessionCredsPromise().then(
      ({ response }) => {
        this.otNetworkTest = new OTNetworkTest(OT, {
          apiKey: response.api_key,
          sessionId: response.session_id,
          token: response.token,
        });
        this.results.session_id = response.session_id;
        this.results.token = response.token;
        
        this.startOTTest();
      },
    ).catch(
      e => {
        console.error(e);
        this.results.error = `Error getting Session and Token: ${e}`;
        this.testEnd();
      },
    );
  }

  startOTTest = () => {
    this.otNetworkTest.testConnectivity().then(this.onTestConnectivitySuccess).catch((e) => {
      this.results.connectivity_test = false;
      this.results.error = `Error during connectivity test: ${e}`;
      this.testEnd();
    });
  }

  onTestConnectivitySuccess = (results) => {
    this.results.connectivity_test = results.success;
    this.results.connectivityResultsRaw = results;
    if (!results.success) {
      this.results.connectivity_error = _.get(results, "failedTests[0].error.name", "Can't connect to OpenTok Servers");
      this.testEnd();
      return;
    }
    this.testQuality();
  }

  testQuality = () => {
    this.results.qualityProgress = [];
    this.otNetworkTest.testQuality(stats => {
      this.results.qualityProgress.push(stats);
    }).then(this.onTestQualitySuccess).catch(e => {
      this.results.error = `Error during quality test: ${e}`;
      this.testEnd();
    });
  }

  onTestQualitySuccess = (results) => {
    this.results.qualityResultsRaw = results;
    this.results.video_supported = results.video && results.video.supported;
    this.results.audio_supported = results.audio && results.audio.supported;
    
    if (results.video.reason) {
      this.results.video_error = `Video not supported: ${results.video.reason}`;
    }
    if (!results.audio.supported) {
      this.results.audio_error = `Audio not supported: ${results.audio.reason}`;
    }
    
    this.testEnd();
  }

  getUserInterfaceConnectionDeatils = () => {
    const deviceDetails = {
      "Engine Name": engineName,
      "Is Mobile": isMobile,
      "Browser Version": browserVersion,
      "Device Type": deviceType,
      "Os Version": osVersion,
      "Os Name": osName,
      "Browser Name": browserName,
    };
    
    this.results.device_details = JSON.stringify(deviceDetails);
  }

  testEnd = () => {
    this.getUserInterfaceConnectionDeatils();
    logNetworkQualityTestPromise(this.results).catch(e => console.error(e));
    try {
      this.sendToAnalytics();
    } catch (e) {
      console.error(`Hotfix. no time for QA... got e: ${e}`);
    }

    this.props.onEnd && this.props.onEnd(this.results);
  }

  sendToAnalytics = async () => {
    const bandwidth_dl_kbps = await getDownloadSpeed(this.results.is_manual);
    const bandwidth_ul_kbps = await getUploadSpeed(this.results.is_manual);

    trackEvent("ot_networktest_results", {
      bandwidth_dl_kbps,
      bandwidth_ul_kbps,
      is_manual: this.results.is_manual,
      connectivity_test: this.results.connectivity_test,
      audio_bitrate: this.results.qualityResultsRaw?.audio?.bitrate,
      audio_packetLossRatio: this.results.qualityResultsRaw?.audio?.packetLossRatio,
      audio_supported: this.results.qualityResultsRaw?.audio?.supported,
      audio_mos: this.results.qualityResultsRaw?.audio?.mos,
      audio_reason: this.results.qualityResultsRaw?.audio?.reason,
      video_bitrate: this.results.qualityResultsRaw?.video?.bitrate,
      video_packetLossRatio: this.results.qualityResultsRaw?.video?.packetLossRatio,
      video_supported: this.results.qualityResultsRaw?.video?.supported,
      video_mos: this.results.qualityResultsRaw?.video?.mos,
      video_reason: this.results.qualityResultsRaw?.video?.reason,
      video_recommended_resolution: this.results.qualityResultsRaw?.video?.recommendedResolution,
      video_recommended_framerate: this.results.qualityResultsRaw?.video?.recommendedFrameRate,
      OT_session_id: this.results.session_id,
    });
  };

  render() {
    return (
      <div />
    );
  }
}

NetworkTest.propTypes = propTypes;

export default (NetworkTest);
